const BOOKING_STATUS = {
  DEFAULT: 0,
  EMAIL_CONFIRMED: 1,
  EMAIL_SENT: 2,
  CANCELED: 3,
  UNBOOKED_FREELANCER: 4,
  DECLINED: 5
};

export default BOOKING_STATUS;
